<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="[{ label: 'SURTIR RECETA' }]"></app-breadcrumb>
    </div>

    <form>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width w-100">
            <mat-label>FOLIO DE LA RECETA</mat-label>
            <input
              [(ngModel)]="searchPrescription"
              aria-autocomplete="none"
              autocomplete="nope"
              matInput
              name="prescriptionID"
              type="text"
              data-tour="supply-folio"
            />
          </mat-form-field>
        </div>

        <!-- SURTIR -->
        <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 mb-2">
          <div class="example-button-row mt-2">
            <button
              (click)="doSearch()"
              color="primary"
              class="w-100"
              mat-flat-button
              data-tour="supply-search">
              SURTIR
            </button>
          </div>
        </div>

        <!-- QR -->
        <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 mb-2" *ngIf="cameraChecked && hasCamera">
          <div class="example-button-row mt-2">
            <button
              (click)="toggleScanner()"
              color="accent"
              class="w-100"
              mat-flat-button
              data-tour="supply-scan">
              ESCANEAR QR
            </button>
          </div>
        </div>

        <!-- VER OCULTOS (solo si aplica) -->
        <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 mb-2" *ngIf="detalle?.detalleOculto">
          <div class="example-button-row mt-2">
            <button
              type="button"
              (click)="openHiddenPinModal()"
              class="w-100 btn-hidden"
              mat-flat-button>
              <mat-icon class="btn-hidden__icon">visibility_off</mat-icon>
              VER OCULTOS
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- ====== SCANNER ====== -->
    <div *ngIf="showScanner" class="qr-scanner-container mt-3">
      <zxing-scanner
        (scanSuccess)="handleQrCodeResult($event)"
        (scanError)="handlePermissionException($event)"
        (permissionResponse)="onHasPermission($event)"
        [formats]="allowedFormats">
      </zxing-scanner>
      <button (click)="toggleScanner()" mat-button>Cancelar</button>
    </div>

    <ng-container *ngIf="detalleDataSource.getValue().length > 0">
      <mat-accordion class="mb-4">
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Informacion general de la receta</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row align-items-stretch gy-3 gx-4">
            <div class="col-lg-4 col-md-6 col-12 d-flex">
              <mat-card class="card-info-vertical flex-fill">
                <mat-card-header>
                  <mat-card-title>
                    <span class="card-title-custom turquesa">Sucursal</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div><strong>Grupo Empresarial:</strong> {{ detalle?.nombreGrupoEmpresarial }}</div>
                  <div><strong>Sucursal:</strong> {{ detalle?.nombreSucursal }}</div>
                  <div><strong>Registro Sanitario:</strong> {{ detalle?.registroSanitario }}</div>
                  <div><strong>Domicilio:</strong> {{ detalle?.domicilioSucursal }}</div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-lg-3 col-md-6 col-12 d-flex">
              <mat-card class="card-info-vertical flex-fill">
                <mat-card-header>
                  <mat-card-title>
                    <span class="card-title-custom turquesa">Paciente</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div><strong>Nombre:</strong> {{ detalle?.nombresPaciente }} {{ detalle?.primerApellidoPaciente }} {{ detalle?.segundoApellidoPaciente }}</div>
                  <div><strong>Genero:</strong> {{ detalle?.genero == 'M' ? 'Masculino' : 'Femenino' }}</div>
                  <div><strong>Altura:</strong> {{ detalle?.pacTalla }} cm</div>
                  <div><strong>Peso:</strong> {{ detalle?.pacPeso }} kg</div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-lg-3 col-md-6 col-12 d-flex">
              <mat-card class="card-info-vertical flex-fill">
                <mat-card-header>
                  <mat-card-title>
                    <span class="card-title-custom turquesa">Medico</span>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div><strong>Nombre:</strong> {{ detalle?.nombresMedico }} {{ detalle?.primerApellidoMedico }} {{ detalle?.segundoApellidoMedico }}</div>
                  <div><strong>Universidad:</strong> {{ detalle?.universidad }}</div>
                  <div><strong>Especialidad:</strong> {{ detalle?.especialidad }}</div>
                  <div><strong>Cedula Esp.:</strong> {{ detalle?.cedulaEspecialidad }}</div>
                  <div><strong>Cedula Gral.:</strong> {{ detalle?.cedulaGeneral }}</div>
                  <div><strong>Tel:</strong> {{ detalle?.movil }}</div>
                  <div><strong>Correo:</strong> {{ detalle?.email }}</div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Medicamentos a surtir</mat-panel-title>
          </mat-expansion-panel-header>

          <mat-card class="mb-4 panel-medicamentos-card">
            <mat-card-content>
              <div class="responsive_table" style="overflow-x:auto;">
                <table [dataSource]="detalleDataSource" class="mat-elevation-z1 w-100" mat-table matSort data-tour="supply-table">
                  <ng-container matColumnDef="nombre">
                    <th mat-header-cell *matHeaderCellDef class="headerCell marino" mat-sort-header style="min-width:280px; max-width:900px; width: 70%;">Medicamento</th>
                    <td mat-cell *matCellDef="let row" matTooltip="{{row.medicamentoNombre}}">
                      <div class="fw-bold mb-0" style="font-size:1.02em;">{{ row.medicamentoNombre }}</div>
                      <div style="font-size:0.97em; color:#003359;">
                        <strong>Dosis:</strong>
                        {{ row.cantidadDiaria }} {{ row.unidadDispensacion }}
                        cada {{ row.frecuency }} {{ row.frecuencyType }}
                        durante {{ row.duracion }} {{ traducirUnidadDuracion(row.duracion, row.unidadDuracion) }}
                        <span *ngIf="row.rutaAdministracion"> via {{ row.rutaAdministracion }}</span>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="piezas">
                    <th mat-header-cell *matHeaderCellDef class="headerCell marino">A surtir</th>
                    <td mat-cell *matCellDef="let row">{{ row.piezas }} pzs</td>
                  </ng-container>

                  <ng-container matColumnDef="cantidadSurtida">
                    <th mat-header-cell *matHeaderCellDef class="headerCell marino">Cantidad surtida</th>
                    <td mat-cell *matCellDef="let row">
                      <input
                        type="number"
                        min="0"
                        [max]="row.piezas"
                        [(ngModel)]="row.cantidadSurtida"
                        [disabled]="selection.isSelected(row)"
                        class="input-surtida"
                        (keydown)="preventInvalidInput($event)"
                        (ngModelChange)="onCantidadSurtidaChange(row)"
                        [ngModelOptions]="{standalone:true}"
                        [name]="'cant_' + row.idDetalleReceta"
                        style="width: 85px; text-align:center; border-radius: 5px; border: 1px solid #d0dde5;"
                        data-tour="supply-qty"
                      />
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef class="headerCell marino">Completo</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-slide-toggle
                        [ngModel]="selection.isSelected(row)"
                        (ngModelChange)="onToggleFull(row, $event)"
                        [ngModelOptions]="{standalone:true}"
                        (click)="$event.stopPropagation()"
                        data-tour="supply-full">
                      </mat-slide-toggle>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></tr>
                </table>
              </div>

              <div class="text-end mt-3">
                <button
                  (click)="surtir()"
                  [disabled]="!canConfirm()"
                  color="primary"
                  mat-raised-button
                  class="btn-turquesa"
                  data-tour="supply-confirm">
                  Confirmar surtido
                </button>
              </div>

            </mat-card-content>
          </mat-card>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
  </div>
</section>
